<template>
	<v-container grid-list-xl setReps>
			<v-layout row wrap>
				<v-flex lg12>
          <h2 v-if="loading == true" style="padding-top: 10%;"><center>Loading Reps<br /><span style="font-size: 12px;">Please Wait</span></center></h2>
          <v-flex xs3 style="padding-left:0px !important;" v-if="loading == false">
            <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
          </v-flex>
          <v-data-table style="margin-top: 0px;" v-if="loading == false" :search="search" :headers="headers" :items="quoteRepsLite" hide-actions class="elevation-1 repLinkTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
            <template slot="items" slot-scope="props" v-if="canShowRow( props.item.name )">
              <td width="15%"><v-switch @change="fncSaveResponsibleRep( props.item )" v-model="props.item.checked"></v-switch></td>
              <td width="45%">{{ props.item.fullname }}</td>
              <td width="40%">{{ props.item.roleName }}</td>
            </template>
          </v-data-table>
				</v-flex>
        <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
          </div>
        </div>
</v-layout>

	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Swatches from 'vue-swatches';
	import "vue-swatches/dist/vue-swatches.min.css";

	export default {
	  name: 'Settings',
	  components: { Swatches },
	  data () {
			return {
			  search: '',
			  loading: true,
        filterRole: 0,
			  responsibleReps: [],
        headers: [
          { text: '', value: '', width: '15%' },
          { text: 'Responsible Rep', value: 'name', width: '45%' },
          { text: 'Role', value: 'name', width: '40%' },
        ],
			};
		},
		methods: {
      canShowRow( item ) {
        if( parseInt(this.filterRole) == 0 ) {
          return true;
        } else {
          var rowId = this.fncExtractData(item, 2);
          if( parseInt(this.filterRole) == parseInt(rowId) ) {
            return true;
          } else {
            return false;
          }
        }
        return false;
      },
      fncExtractData( data, index ) {
        var splitData = data.split('|');
        return splitData[index];
      },
      fncSaveResponsibleRep( row ) {

        //this.$store.dispatch('fncUpdateQuoteReps', item)
        var addedReps = [];
        for( var r in this.quoteRepsLite ) {
          if( this.quoteRepsLite[r].checked == true ) {
            addedReps.push( this.quoteRepsLite[r].userid );
          }
        }

        this.$store.dispatch({
          type: 'fncUpdateQuoteRepsSwitch',
          id: this.globalModalParams.object.id,
          new_responsible_reps_ids_obj: addedReps
        })

        /*var newResponsibleRep = [];

        for( var r in this.quoteRepsLite ) {
          if(this.quoteRepsLite[r].checked == true) {
            newResponsibleRep.push( this.quoteRepsLite[r] );
          }
        }
        for( var r in this.quoteRepsLite ) {
          if(this.quoteRepsLite[r].checked == false) {
            newResponsibleRep.push( this.quoteRepsLite[r] );
          }
        }*/

        this.$store.commit('fncSetQuoteRepsLite', []);

        var oldThis = this;

        setTimeout(function() {
          oldThis.$store.dispatch({
            type: 'fncPopulateLinkedUsersLite',
            quote: oldThis.globalModalParams.object.id
          });
        }, 1000)

        /*this.$store.dispatch({
          type: 'fncPopulateLinkedUsersLite',
          quote: this.globalModalParams.object.id
        });*/

      },
      fncHideModal () {
        // this.$store.commit('hideModal');
        window.location.reload();
      }
		},
    beforeMount() {

      this.$store.dispatch({
        type: 'fncPopulateLinkedUsersLite',
        quote: this.globalModalParams.object.id
      });

    },
    mounted() {

	    /*var modalParams = this.globalModalParams;
      var mountedThis = this;

      this.filterRole = modalParams.roleId;

	    setTimeout(function() {
        for( var r in modalParams.object.responsible_user_list ) {
          var isChecked = false;
          if( modalParams.object.new_responsible_reps_ids_obj && modalParams.object.new_responsible_reps_ids_obj.indexOf(r) != -1 ) {
            isChecked = true;
          }
          if( isChecked == true ) {
            mountedThis.responsibleReps.push({ id: r, name: modalParams.object.responsible_user_list[r], checked: isChecked });
          }
        }
        for( var r in modalParams.object.responsible_user_list ) {
          var isChecked = false;
          if( modalParams.object.new_responsible_reps_ids_obj && modalParams.object.new_responsible_reps_ids_obj.indexOf(r) != -1 ) {
            isChecked = true;
          }
          if( isChecked == false ) {
            mountedThis.responsibleReps.push({ id: r, name: modalParams.object.responsible_user_list[r], checked: isChecked });
          }
        }

        mountedThis.loading = false;
      }, 1000)*/
    },
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
        'quoteRepsLite'
			])
		},
    watch: {
	    quoteRepsLite() {
	      if( this.quoteRepsLite.length == 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }

      }
    }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
